// extracted by mini-css-extract-plugin
export default {"btn":"RedBtnSmall_btn__w4BtK","digit":"RedBtnSmall_digit__8JSwd","large-digit":"RedBtnSmall_large-digit__OJ111"};